module.exports = __webpack_public_path__ + "static/media/assembleenationale.81e3afa1.jpg";